
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen py-20 px-6 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-gray-900 dark:text-white">
            Privacy Policy
          </h1>
          
          <div className="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-8">
            <div className="prose prose-lg max-w-none dark:prose-invert">
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Last updated: January 1, 2024
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Information We Collect</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                We collect information you provide directly to us, such as when you contact us for rust protection services, request assessments, or communicate with our team.
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">How We Use Your Information</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                We use the information we collect to provide, maintain, and improve our rust protection services, respond to your inquiries, and communicate with you about our services.
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Information Sharing</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this privacy policy.
              </p>
              
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Contact Us</h2>
              <p className="text-gray-600 dark:text-gray-300">
                If you have any questions about this Privacy Policy, please contact us at contact@rust-squad.com.
              </p>
            </div>
          </div>
        </div>
      </div>
  );
};

export default PrivacyPolicy;
